export default {
  name: 'my',
  el: {
    breadcrumb: {
      label: 'ဘရတ်ဒ်ခရမ်',
    },
    colorpicker: {
      confirm: 'အိုကေ',
      clear: 'ရှင်းမယ်',
      defaultLabel: 'အရောင်ရွေးချယ်ပါ',
      description:
        'လက်ရှိအရောင်မှာ {color} ဖြစ်ပါသည်။ တခြားအရောင်ကိုရွေးချယ်လိုပါက enter ကိုနှိပ်ပါ။',
      alphaLabel: 'alpha တန်ဖိုးကို ရွေးချယ်ပါ',
    },
    datepicker: {
      now: 'ယခု',
      today: 'ယနေ့',
      cancel: 'ပယ်ဖျက်',
      clear: 'ရှင်းမယ်',
      confirm: 'အိုကေ',
      dateTablePrompt:
        'arrow keys နှင့် enter ကိုအသုံးပြုပြီး နေ့ရက် ကိုရွေးချယ်ပါ',
      monthTablePrompt:
        'arrow keys နှင့် enter ကိုအသုံးပြုပြီး လ ကိုရွေးချယ်ပါ',
      yearTablePrompt:
        'arrow keys နှင့် enter ကိုအသုံးပြုပြီး နှစ် ကိုရွေးချယ်ပါ',
      selectedDate: 'ရွေးချယ်ထားသော ရက်စွဲ',
      selectDate: 'ရက်စွဲကို ရွေးချယ်ပါ',
      selectTime: 'အချိန်ကို ရွေးချယ်ပါ',
      startDate: 'စတင်မည့်ရက်စွဲ',
      startTime: 'စတင်မည့်အချိန်',
      endDate: 'ကုန်ဆုံးမည့်ရက်စွဲ',
      endTime: 'ကုန်ဆုံးမည့်အချိန်',
      prevYear: 'ယခင်နှစ်',
      nextYear: 'နောက်နှစ်',
      prevMonth: 'ယခင်လ',
      nextMonth: 'နောက်လ',
      year: '',
      month1: 'ဇန်နဝါရီ',
      month2: 'ဖေဖော်ဝါရီ',
      month3: 'မတ်',
      month4: 'ဧပြီ',
      month5: 'မေ',
      month6: 'ဇွန်',
      month7: 'ဇူလိုင်',
      month8: 'သြဂုတ်',
      month9: 'စက်တင်ဘာ',
      month10: 'အောက်တိုဘာ',
      month11: 'နိုဝင်ဘာ',
      month12: 'ဒီဇင်ဘာ',
      weeks: {
        sun: 'နွေ',
        mon: 'လာ',
        tue: 'ဂါ',
        wed: 'ဟူး',
        thu: 'ကြာ',
        fri: 'သော',
        sat: 'နေ',
      },
      weeksFull: {
        sun: 'တနင်္ဂနွေ',
        mon: 'တနင်္လာ',
        tue: 'အင်္ဂါ',
        wed: 'ဗုဒ္ဓဟူး',
        thu: 'ကြာသပတေး',
        fri: 'သောကြာ',
        sat: 'စနေ',
      },
      months: {
        jan: 'ဇန်',
        feb: 'ဖေ',
        mar: 'မတ်',
        apr: 'ပြီ',
        may: 'မေ',
        jun: 'ဇွန်',
        jul: 'လိုင်',
        aug: 'ဩ',
        sep: 'စက်',
        oct: 'အောက်',
        nov: 'နို',
        dec: 'ဒီ',
      },
    },
    inputNumber: {
      decrease: 'အရေအတွက်လျှော့ချ',
      increase: 'အရေအတွက်တိုး',
    },
    select: {
      loading: 'ဝန်တင်နေသည်',
      noMatch: 'ကိုက်ညီသောဒေတာမရှိပါ',
      noData: 'ဒေတာမရှိပါ',
      placeholder: 'ရွေးပါ',
    },
    mention: {
      loading: 'ဝန်တင်နေသည်',
    },
    dropdown: {
      toggleDropdown: 'Dropdown စာရင်း ဖွင့်/ပိတ်',
    },
    cascader: {
      noMatch: 'ကိုက်ညီသောဒေတာမရှိပါ',
      loading: 'ဝန်တင်နေသည်',
      placeholder: 'ရွေးပါ',
      noData: 'ဒေတာမရှိပါ',
    },
    pagination: {
      goto: 'သွားမယ်',
      pagesize: '/စာမျက်နှာ',
      total: 'စုစုပေါင်း {total}',
      pageClassifier: '',
      page: 'စာမျက်နှာ',
      prev: 'ရှေ့စာမျက်နှာသို့',
      next: 'နောက်စာမျက်နှာသို့',
      currentPage: 'စာမျက်နှာ {pager}',
      prevPages: 'ရှေ့စာမျက်နှာ {pager} သို့',
      nextPages: 'နောက်စာမျက်နှာ {pager} သို့',
      deprecationWarning:
        'ကန့်ကွက်ထားသော အသုံးပြုမှုများကို တွေ့ရှိပါသည်။ အသေးစိတ်အချက်အလက်များကို el-pagination ရဲ့စာရွက်စာတမ်းတွင် ဖတ်ရှုပါ။',
    },
    dialog: {
      close: 'ဤဒိုင်ယာလော့ဂ်ကို ပိတ်ပါ',
    },
    drawer: {
      close: 'ဤဒိုင်ယာလော့ဂ်ကို ပိတ်ပါ',
    },
    messagebox: {
      title: 'မက်ဆေ့ချ်',
      confirm: 'အိုကေ',
      cancel: 'ပယ်ဖျက်',
      error: 'တရားမဝင်ထည့်သွင်းမှု',
      close: 'ဤဒိုင်ယာလော့ဂ်ကို ပိတ်ပါ',
    },
    upload: {
      deleteTip: 'ဖယ်ရှားရန် ဖျက်မည် ကိုနှိပ်ပါ',
      delete: 'ဖျက်မည်',
      preview: 'အစမ်းကြည့်မည်',
      continue: 'ရှေ့ဆက်မည်',
    },
    slider: {
      defaultLabel: '{min} နှင့် {max} ကြားရှိ ဆလိုက်ဒါ',
      defaultRangeStartLabel: 'စတင်တန်ဖိုးကို ရွေးပါ',
      defaultRangeEndLabel: 'အဆုံးသတ်တန်ဖိုးကို ရွေးပါ',
    },
    table: {
      emptyText: 'ဒေတာမရှိပါ',
      confirmFilter: 'အတည်ပြုမည်',
      resetFilter: 'ပြန်လည်သတ်မှတ်မည်',
      clearFilter: 'အားလုံး',
      sumText: 'ပေါင်းလဒ်',
    },
    tour: {
      next: 'နောက်သို့',
      previous: 'ရှေ့သို့',
      finish: 'ပြီးပြီ',
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'ဒေတာမရှိပါ',
    },
    transfer: {
      noMatch: 'ကိုက်ညီသောဒေတာမရှိပါ',
      noData: 'ဒေတာမရှိပါ',
      titles: ['စာရင်း ၁', 'စာရင်း ၂'],
      filterPlaceholder: 'သော့ချက်စကားလုံးကို ရိုက်ထည့်ပါ',
      noCheckedFormat: '{total} ခု',
      hasCheckedFormat: '{checked}/{total} ရွေးပြီး',
    },
    image: {
      error: 'မအောင်မြင်ပါ',
    },
    pageHeader: {
      title: 'ပြန်မည်',
    },
    popconfirm: {
      confirmButtonText: 'ဟုတ်ကဲ့',
      cancelButtonText: 'မလုပ်တော့ဘူး',
    },
    carousel: {
      leftArrow: 'ကာရူဆယ် မြား ဘယ်ဘက်',
      rightArrow: 'ကာရူဆယ် မြား ညာဘက်',
      indicator: 'ကာရူဆယ် အညွှန်း {index} သို့ ပြောင်းရန်',
    },
  },
}
